import { render, staticRenderFns } from "./Model.vue?vue&type=template&id=17540a5c&scoped=true"
import script from "./model.js?vue&type=script&lang=js&external"
export * from "./model.js?vue&type=script&lang=js&external"
import style0 from "./model.scss?vue&type=style&index=0&id=17540a5c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17540a5c",
  null
  
)

export default component.exports